const LEDGER_IMG =
  "https://images.pexels.com/photos/4458203/pexels-photo-4458203.jpeg?auto=compress&cs=tinysrgb&w=1000";

export default function Governance() {
  return (
    <section
      id="compliance"
      className="py-24 px-6 bg-parchment-deep border-b border-linen"
      data-testid="governance-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="font-mono text-xs uppercase tracking-widest text-clay font-bold">
              Audit Assurance
            </span>
            <h2 className="font-display text-3xl md:text-4xl text-ink mt-2 mb-6">
              Continuous enterprise governance and observability
            </h2>
            <p className="font-body text-umber mb-6 leading-relaxed">
              SureLoom provides real-time latency graphs, prompt logging, and
              automated policy enforcement certified across global standards.
            </p>

            <div
              className="p-6 bg-ivory border border-[#DCD5C6] rounded-none mb-6"
              data-testid="audit-record-note"
            >
              <span className="font-mono text-xs uppercase text-stone block mb-1">
                Audit Record
              </span>
              <p className="font-body text-sm text-umber">
                Customer references and audit certifications are available under
                enterprise NDA during technical review.
              </p>
            </div>
          </div>

          <div className="relative aspect-square border border-ink bg-[#1A120C] p-2">
            <div className="absolute inset-2 overflow-hidden">
              <img
                src={LEDGER_IMG}
                alt="Cryptographic enterprise ledger"
                loading="lazy"
                className="w-full h-full object-cover sl-drift sl-grade"
                data-testid="governance-image"
              />
            </div>
            <div className="absolute bottom-6 left-6 right-6 text-white text-xs font-mono z-10">
              Audit Protocol &bull; SOC 2 Type II Certified
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
